/**
 * 仕入取引種別
 */
export enum PurchaseTradeTypeCodeEnum {
  /** 通常 */ NORMAL = '01',
  /** 摘要 */ REMARK = '02',
  /** 返品(良品) */ RETURN_NOT_DAMAGED = '03',
  /** 返品(不良品) */ RETURN_DAMAGED = '04',
  /** 送料 */ POSTAGE = '05',
  /** 手数料 */ CHARGE = '06',
  /** 値引 */ DISCOUNT = '07',
  /** 交換 */ CHANGED = '08',
  /** 消費税 */ TAX = '09',
}

/**
 * 仕入取引種別
 */
export const PurchaseTradeTypeCode = [
  { label: '通常', value: PurchaseTradeTypeCodeEnum.NORMAL },
  { label: '摘要', value: PurchaseTradeTypeCodeEnum.REMARK },
  { label: '返品(良品)', value: PurchaseTradeTypeCodeEnum.RETURN_NOT_DAMAGED },
  { label: '返品(不良品)', value: PurchaseTradeTypeCodeEnum.RETURN_DAMAGED },
  { label: '送料', value: PurchaseTradeTypeCodeEnum.POSTAGE },
  { label: '手数料', value: PurchaseTradeTypeCodeEnum.CHARGE },
  { label: '値引', value: PurchaseTradeTypeCodeEnum.DISCOUNT },
  { label: '交換', value: PurchaseTradeTypeCodeEnum.CHANGED },
  { label: '消費税', value: PurchaseTradeTypeCodeEnum.TAX },
];
